import { createContext, useContext, useEffect, useState } from "react";
import api, { errMsg } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("iep_token");
    const cachedUser = localStorage.getItem("iep_user");
    if (token && cachedUser) {
      try { setUser(JSON.parse(cachedUser)); } catch (_) {}
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("iep_user", JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem("iep_token");
        localStorage.removeItem("iep_user");
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const persist = (token, u) => {
    localStorage.setItem("iep_token", token);
    localStorage.setItem("iep_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      persist(data.token, data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: errMsg(e.response?.data?.detail, "Login failed") };
    }
  };

  const register = async (email, password, name, extra = {}) => {
    try {
      const { data } = await api.post("/auth/register", { email, password, name, ...extra });
      persist(data.token, data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: errMsg(e.response?.data?.detail, "Registration failed") };
    }
  };

  const logout = () => {
    localStorage.removeItem("iep_token");
    localStorage.removeItem("iep_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
